"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Allotments = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const roundMoney_1 = require("../../../../../../utils/roundMoney");
const verify_1 = require("../../../../../../utils/verify");
const Sub_1 = require("../../../../../Page/Title/Sub");
const tariffGroupMapper_1 = require("../../../../../TariffsTable/tariffGroupMapper");
const FlightInfoTable_1 = require("../FlightInfoTable");
const SeatNumber_1 = require("../SeatNumber");
require("./index.scss");
const className = 'flight-list-info-allotments';
const tableColumns = [
    {
        Header: '',
        id: 'agentName',
        disableSortBy: true,
        Cell: ({ row }) => {
            const allotment = row.original;
            return (react_1.default.createElement("span", null, allotment.agent.displayName));
        },
    },
    {
        Header: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List/Info:AllotmentsNumberOfSeats', defaultMessage: 'Number of seats' })),
        id: 'seatsNumber',
        disableSortBy: true,
        Cell: ({ row }) => {
            const { seatsNumber } = row.original;
            const tariffGroup = (0, verify_1.verifyTariffGroup)(row.original.tariffGroup);
            const tariffGroupCode = (0, tariffGroupMapper_1.mapTariffGroupIdToCode)(tariffGroup === null || tariffGroup === void 0 ? void 0 : tariffGroup.id);
            if (!tariffGroup)
                return null;
            if (!tariffGroupCode)
                return null;
            return (react_1.default.createElement("div", { className: `${className}__numbers` },
                react_1.default.createElement(SeatNumber_1.SeatNumber, { type: tariffGroupCode, seatNumber: seatsNumber })));
        },
    },
    {
        Header: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List/Info:AllotmentsPricePerSeat', defaultMessage: 'Price per seat' })),
        id: 'pricePerSeat',
        Cell: ({ row }) => {
            const { locale } = (0, react_intl_1.useIntl)();
            return ((0, roundMoney_1.localizeMoney)(row.original.costPerSeat, locale, 'Flight/List/Info/Allotments/costPerSeat'));
        },
    },
    {
        Header: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List/Info:AllotmentsTotal', defaultMessage: 'Total' })),
        id: 'total',
        Cell: ({ row }) => {
            const { locale } = (0, react_intl_1.useIntl)();
            return ((0, roundMoney_1.localizeMoney)(row.original.total, locale, 'Flight/List/Info/Allotments/total'));
        },
    },
];
const Allotments = (props) => {
    const { flightAllotments, allotmentHidden, } = props;
    if (!flightAllotments)
        return null;
    if (allotmentHidden)
        return null;
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(Sub_1.PageSubTitle, { icon: 'iconmonstr-retweet-1-2', text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List/Info:Allotments', defaultMessage: 'Allotments' }), modificators: 'margin-bottom-sm' }),
        react_1.default.createElement(FlightInfoTable_1.FlightInfoTable, { columns: tableColumns, data: flightAllotments })));
};
exports.Allotments = Allotments;
//# sourceMappingURL=index.js.map